<div class="responsive-sidebar-toggle-btn" (click)="clickEvent()">
    <app-button *ngIf="!sidebarOpen">
      <i class="fas" [ngClass]="{ 'fa-bars': !sidebarOpen, 'fa-times': sidebarOpen }"></i>
    </app-button>
    <app-button *ngIf="sidebarOpen" buttonType="danger">
      <i class="fas" [ngClass]="{ 'fa-bars': !sidebarOpen, 'fa-times': sidebarOpen }"></i>
    </app-button>
</div>